import PropTypes from 'prop-types'
import { Card, CardBody, CardHeader } from 'reactstrap'
//
import CustomButton from 'components/Buttons/CustomButton'
import Skeleton from 'components/Skeleton'
import useIsMobile from 'hooks/useIsMobile'
import { formatNumber } from '../../utils/formatNumber'
import { ButtonIcon } from '../Buttons'
import SvgIcon from 'components/Icon/SvgIcon'
import { useOutletContext } from 'react-router-dom'
import colors from 'Theme/colors'

const CardBankAccount = (props) => {
  const {
    title = 'No Title',
    bankAmount = 0,
    btnTitle = 'No Button Title',
    iconCard,
    btnIcon,
    isLoading,
    isSuccess,
    handleClick,
    isDisable,
    isProcess,
    processMsg,
    onClickHeader,
    noHover,
    isNoButtonTitle = false,
    cardThemeColor,
    iconName,
    testId = 'card-bank-account'
  } = props

  const isMobile = useIsMobile()
  const profile = useOutletContext()
  
  return (
    <Card 
      className={`h-100 border-0 shadow-sm transition-all ${cardThemeColor ? 'text-white' : ''}`}
      data-testid={testId}
      style={{
        background: cardThemeColor ? `linear-gradient(135deg, ${cardThemeColor} 0%, ${colors.primary[500]} 100%)` : '#fff',
        color: cardThemeColor ? '#ffffff' : 'inherit',
        cursor: isDisable || noHover ? 'default' : 'pointer',
        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        borderRadius: '20px',
        border: cardThemeColor ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
        boxShadow: cardThemeColor 
          ? '0 10px 20px -5px rgba(0, 99, 134, 0.3)' 
          : '0 8px 24px -4px rgba(0, 0, 0, 0.08), 0 4px 12px -4px rgba(0, 0, 0, 0.04)',
        overflow: 'hidden',
        position: 'relative'
      }}
      onMouseEnter={(e) => {
        if (!isDisable && !noHover) {
          e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)'
          e.currentTarget.style.boxShadow = cardThemeColor 
            ? '0 20px 25px -5px rgba(0, 99, 134, 0.4)' 
            : '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
        }
      }}
      onMouseLeave={(e) => {
        if (!isDisable && !noHover) {
          e.currentTarget.style.transform = 'translateY(0) scale(1)'
          e.currentTarget.style.boxShadow = cardThemeColor 
            ? '0 10px 20px -5px rgba(0, 99, 134, 0.3)' 
            : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      {cardThemeColor && (
        <div style={{
          position: 'absolute',
          top: '-20%',
          right: '-10%',
          width: '140px',
          height: '140px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          filter: 'blur(30px)',
          pointerEvents: 'none'
        }} />
      )}
      <CardHeader
        className="py-3 px-4"
        style={{
          backgroundColor: 'transparent',
          borderBottom: 'none',
          zIndex: 1
        }}
        onClick={() => {
          if (!isDisable) {
            onClickHeader?.()
          }
        }}
      >
        <div className="d-flex align-items-center" style={{ gap: '16px' }}>
          {(iconName || iconCard) && (
            <div className="flex-shrink-0 mt-1">
              <div 
                className={iconName ? "rounded-circle d-flex align-items-center justify-content-center" : "d-flex align-items-center justify-content-center"}
                style={iconName ? {
                  backgroundColor: cardThemeColor ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.05)',
                  backdropFilter: cardThemeColor ? 'blur(8px)' : 'none',
                  border: cardThemeColor ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid rgba(0, 0, 0, 0.05)',
                  width: '48px',
                  height: '48px',
                  boxShadow: cardThemeColor ? 'inset 0 0 10px rgba(255,255,255,0.1)' : 'none'
                } : {
                  width: '48px',
                  height: '48px',
                }}
              >
                {iconCard ? (
                  <img
                    src={iconCard}
                    style={{ 
                      width: '40px', 
                      height: '40px', 
                      objectFit: 'contain',
                    }}
                    alt={title}
                  />
                ) : (
                  <SvgIcon 
                    name={iconName} 
                    color={cardThemeColor ? "white" : colors.primary[400]}
                  />
                )}
              </div>
            </div>
          )}
          <div className="d-flex flex-column" style={{ minWidth: 0 }}>
            <span className={`${cardThemeColor ? '' : 'text-dark'} fw-semibold`} style={{ fontSize: '13px', opacity: cardThemeColor ? 0.85 : 1, marginBottom: '2px' }}>
              {title}
            </span>
            <span 
              className={`${cardThemeColor ? 'text-white' : 'text-primary'} fw-bold text-truncate`} 
              style={{ fontSize: '20px', letterSpacing: '-0.5px', lineHeight: '1.2' }}
              title={isSuccess ? `Rp${formatNumber(bankAmount)}` : ''}
            >
              <span style={{ fontSize: '13px', marginRight: '2px', fontWeight: 600 }}>Rp</span>
              {isLoading && !isSuccess ? (
                <Skeleton width="100px" height="24px" />
              ) : isSuccess ? (
                formatNumber(bankAmount)
              ) : (
                <Skeleton width="100px" height="24px" />
              )}
            </span>
          </div>
        </div>
      </CardHeader>
      
      {!isNoButtonTitle && (
        <CardBody className="px-4 pb-4 pt-3 d-flex flex-column justify-content-end" style={{ flexGrow: 1 }}>
          {isProcess && !isMobile ? (
            <CustomButton
              block
              className="w-100 border-0 text-start px-3 py-0 d-flex align-items-center mt-auto transition-all"
              testId={`${testId}-button`}
              style={{
                backgroundColor: cardThemeColor ? 'rgba(255,255,255,0.15)' : '#FFF1E5',
                backdropFilter: cardThemeColor ? 'blur(4px)' : 'none',
                border: cardThemeColor ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
                color: cardThemeColor ? '#ffffff' : '#E0650D',
                borderRadius: '10px',
                height: '42px',
                boxShadow: cardThemeColor ? 'inset 0 0 10px rgba(255,255,255,0.05)' : 'none'
              }}
              onClick={handleClick}
              onMouseEnter={(e) => {
                if (cardThemeColor) {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'
                }
              }}
              onMouseLeave={(e) => {
                if (cardThemeColor) {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'
                }
              }}
            >
              <div className="d-flex align-items-center w-100">
                <span 
                  className="flex-grow-1 text-truncate" 
                  style={{ 
                    fontSize: '13px', 
                    fontWeight: 500,
                  }}
                  title={processMsg}
                >
                  {processMsg}
                </span>
                <span className="fw-bold ms-2 flex-shrink-0" style={{ fontSize: '13px' }}>Cek &rarr;</span>
              </div>
            </CustomButton>
          ) : (
            <ButtonIcon
              btnTitle={btnTitle}
              icon={btnIcon}
              testId={`${testId}-button`}
              btnProps={{
                className: "w-100 justify-content-center py-0 d-flex align-items-center mt-auto transition-all",
                style: { 
                  borderRadius: '10px', 
                  fontWeight: 600,
                  fontSize: '14px',
                  border: cardThemeColor ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid #006386',
                  color: cardThemeColor ? '#ffffff' : colors.primary[400],
                  backgroundColor: cardThemeColor ? 'rgba(255,255,255,0.15)' : 'white',
                  backdropFilter: cardThemeColor ? 'blur(4px)' : 'none',
                  height: '42px',
                  boxShadow: cardThemeColor ? 'inset 0 0 10px rgba(255,255,255,0.05)' : 'none'
                },
                disabled: isDisable ?? true,
                onClick: handleClick,
                onMouseEnter: (e) => {
                  if (cardThemeColor) {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'
                  }
                },
                onMouseLeave: (e) => {
                  if (cardThemeColor) {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'
                  }
                }
              }}
            />
          )}
        </CardBody>
      )}
    </Card>
  )
}

CardBankAccount.propTypes = {
  title: PropTypes.string,
  bankAmount: PropTypes.number,
  iconCard: PropTypes.string,
  btnTitle: PropTypes.string,
  btnIcon: PropTypes.object,
  handleClick: PropTypes.func,
  isDisable: PropTypes.bool,
}
export default CardBankAccount
